<template>
    <div class="qr-field-component-viewer" :class="{ 'is-placeholder': !qrConfig }" :style="computedStyle">
        {{ displayText }}
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class QrFieldComponentViewer extends Vue {
    @Prop() item: OM.QrFieldComponent;
    @Prop({ default: null }) qrConfig: OM.QrConfig;

    get displayText() {
        if (this.qrConfig) {
            if (this.item.fieldType === 'name') return this.qrConfig.name;
            if (this.item.fieldType === 'description') return this.qrConfig.description;
            return this.qrConfig.info;
        }
        if (this.item.fieldType === 'name') return '[Nome QR]';
        if (this.item.fieldType === 'description') return '[Descrizione QR]';
        return '[Info QR]';
    }

    get computedStyle() {
        const style: any = {};
        if (this.item.fontSize)   style.fontSize   = this.item.fontSize + 'px';
        if (this.item.fontFamily) style.fontFamily  = this.item.fontFamily;
        if (this.item.color)      style.color       = this.item.color;
        if (this.item.fontWeight) style.fontWeight  = this.item.fontWeight;
        if (this.item.textAlign)  style.textAlign   = this.item.textAlign;
        if (this.item.width)      style.width       = this.item.width  + 'px';
        if (this.item.height)     style.height      = this.item.height + 'px';
        return style;
    }
}
</script>

<style scoped>
.qr-field-component-viewer {
    white-space: pre-wrap;
    word-wrap: break-word;
    display: inline-block;
    min-width: 20px;
    min-height: 20px;
    overflow: hidden;
}

.is-placeholder {
    border: 1px dashed #aaa;
    padding: 1px 4px;
    border-radius: 3px;
    background: rgba(0, 123, 255, 0.04);
}
</style>
